import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
import { ProblemSection } from './components/ProblemSection';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { ForWhoSection } from './components/ForWhoSection';
import { TestimonialsSection } from './TestimonialsSection';
import { TimelineSection } from './components/TimelineSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Preconnect to CDN for faster image loading
    const cdnPreconnect = document.createElement('link');
    cdnPreconnect.rel = 'preconnect';
    cdnPreconnect.href = 'https://cdn.magicpatterns.com';
    document.head.appendChild(cdnPreconnect);
    // DNS prefetch for checkout domain
    const checkoutPrefetch = document.createElement('link');
    checkoutPrefetch.rel = 'dns-prefetch';
    checkoutPrefetch.href = 'https://checkout.construyeprogreso.com';
    document.head.appendChild(checkoutPrefetch);
    // Preload Google Fonts non-blocking
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap';
    fontLink.media = 'print';
    fontLink.onload = () => {
      fontLink.media = 'all';
    };
    document.head.appendChild(fontLink);
    // Meta Pixel - deferred to avoid blocking render
    let pixelScript: HTMLScriptElement | null = null;
    let noscript: HTMLElement | null = null;
    const pixelTimeout = setTimeout(() => {
      pixelScript = document.createElement('script');
      pixelScript.async = true;
      pixelScript.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1484251876624503');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(pixelScript);
      noscript = document.createElement('noscript');
      noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1484251876624503&ev=PageView&noscript=1" />`;
      document.body.appendChild(noscript);
    }, 3000);
    return () => {
      clearTimeout(pixelTimeout);
      document.head.removeChild(cdnPreconnect);
      document.head.removeChild(checkoutPrefetch);
      document.head.removeChild(fontLink);
      if (pixelScript) document.head.removeChild(pixelScript);
      if (noscript) document.body.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen font-sans selection:bg-blue-500 selection:text-white bg-gray-950" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <TrustBar data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <TomosSection data-id="element-6" />
        <BonusSection data-id="element-7" />
        <ForWhoSection data-id="element-8" />
        <TimelineSection data-id="element-9" />
        <PricingSection data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <TestimonialsSection data-id="element-12" />
        <FAQSection data-id="element-13" />
        <FinalCTASection data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
      <SocialProofPopup data-id="element-16" />
    </div>;
}